<template>
    <div>
        <h3 class="learnworlds-heading3 learnworlds-element learnworlds-heading3-normal">
            <span v-if="activeComponent === 'RegisterComponent'">
                {{ i18n.get('common.login_signup') }}
            </span>

            <span v-else-if="activeComponent === 'LoginComponent'">
                {{ i18n.get('common.login_login') }}
            </span>
        </h3>
        
        <component ref="activeAuthenticationView" 
                   :is="activeComponent" 
                   v-bind="activeComponentProps" 
                   @changeView="setActiveComponent"></component>

        <div class="learnworlds-main-text learnworlds-main-text-normal learnworlds-element">
            <span v-if="activeComponent === 'RegisterComponent'">
                <span>
                    {{ i18n.get('common.login_do_you_already_have_an_account_message') }} 
                </span>
                
                <span @click="setActiveComponent('LoginComponent')" 
                      class="lw-link-text lw-cursor-pointer">
                    {{ i18n.get('common.here') }}.
                </span>
            </span>

            <span v-else-if="activeComponent === 'LoginComponent'">
                <span>
                    {{ i18n.get('common.login_account_does_not_exist_message') }} 
                </span>
                
                <span @click="setActiveComponent('RegisterComponent')" 
                      class="lw-link-text lw-cursor-pointer">
                    {{ i18n.get('common.here') }}.
                </span>
            </span>
        </div>
    </div>
</template>

<script>
    import LoginComponent from "./LoginComponent";
    import RegisterComponent from "./RegisterComponent";
    import ForgotPasswordComponent from "./ForgotPasswordComponent";

    export default {
        name: "AuthenticationComponent",

        data() {
            return {
                activeComponent: 'RegisterComponent'
            }
        },
        
        computed: {
            activeComponentProps() {
                const props = {
                    'LoginComponent': {
                        successCallback : this.successLoginCallback,
                        showSubmitButtons: this.showSubmitButtons,
                        showForgotPassword: this.showForgotPassword
                    },
                    
                    'RegisterComponent': {
                        successCallback : this.successRegistrationCallback,
                        showSubmitButtons: this.showSubmitButtons,
                        withoutTerms: this.withoutTerms,
                        withoutMarketingOptIn: this.withoutMarketingOptIn,
                        onlyRequiredFields: this.onlyRequiredFields,
                        additionalAuthenticatonFormData: this.additionalAuthenticatonFormData,
                    }
                };
                
                return props[this.activeComponent];
            },
        },
        
        methods: {
            setActiveComponent(view) {
                if(typeof view == 'string'){
                    return this.activeComponent = view;
                }
                return this.activeComponent = view.view;
                
            },
            
            authenticate() {
                return this.$refs.activeAuthenticationView.authenticate();
            }
        },
        
        props: {
            successLoginCallback: {
                type: Function,
                default: (redirectUrl) => {
                    window.location.replace(redirectUrl);
                }
            },
            
            successRegistrationCallback: {
                type: Function,
                default: (redirectUrl) => {
                    window.location.replace(redirectUrl);
                }
            },
            
            showSubmitButtons: {
                type: Boolean,
                default: true
            },
            
            showForgotPassword: {
                type: Boolean,
                default: true
            }, 
            
            withoutTerms: {
                type: Boolean,
                default: false
            },
            
            withoutMarketingOptIn: {
                type: Boolean,
                default: false
            },
            
            onlyRequiredFields: {
                type: Boolean,
                default: false
            },
            
            additionalAuthenticatonFormData: {
                type: Object,
                default(){
                    return {};
                }
            }
        },
        
        components: {
            LoginComponent,
            RegisterComponent,
            ForgotPasswordComponent
        }
    }
</script>
